export const formatExpirationDate = (value: string): string => {
   // Remove all non-digit characters
   const digits = value.replace(/\D/g, '');
   if (digits.length === 0) return '';
   // If less than 2 digits, just return the digits
   if (digits.length < 2) return digits;
   // Otherwise, insert a slash after the first two digits and only use up to 4 digits
   const month = digits.substring(0, 2);
   const year = digits.substring(2, 4);
   return year ? `${month}/${year}` : month;
};

export const convertToExpiration = (input: string) => {
   if (!input) {
      throw new Error('Input must be a non-empty string');
   }
   // If input is 6 characters long (MMYYYY)
   if (input.length === 6) {
      const month = input.substring(0, 2);
      const year = input.substring(4, 6); // get the last two digits of the year
      return `${month}/${year}`;
   }
   // Optionally, handle already MMYY format:
   else if (input.length === 4) {
      const month = input.substring(0, 2);
      const year = input.substring(2, 4);
      return `${month}/${year}`;
   } else {
      throw new Error('Input must be in MMYYYY or MMYY format.');
   }
};
